import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Badge, Box, Button, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReviewReportCreate from './ReviewReportCreate';
import ReviewReportEdit from './ReviewReportEdit';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';
import { useListReviewAbuseReportsQuery } from '../features/api/rest/apiReviewsReportsSlice';

function ReviewReport({ reviewId, owner }) {
  const { ean } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [showModal, setShowModal] = React.useState(false);
  const { data: fetchedReports } = useListReviewAbuseReportsQuery({ ean, reviewId });
  const { user } = useGetProfileQuery(undefined, {
    selectFromResult: ({ currentData }) => ({
      user: currentData?.username,
    }),
  });

  const handleClick = () => {
    if (!fetchedReports || !user) {
      navigate('/login', { state: { next: `${location.pathname}${location.search}` } });
      return;
    }
    setShowModal(true);
  };
  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <>
      {user !== owner ? (
        <Badge badgeContent="!" color="error" invisible={!fetchedReports?.length > 0} sx={{ ml: 2 }}>
          <Button variant="contained" size="small" sx={{ textTransform: 'none', fontSize: 13, color: 'grey.500', bgcolor: 'grey.100', '&:hover': { bgcolor: 'grey.200' } }} onClick={handleClick}>
            {t('reports.button.default')}
          </Button>
        </Badge>
      ) : (
        <Typography variant="button" sx={{ ml: 2, color: 'grey.500', textTransform: 'none', fontSize: 13 }}>
          {t('reports.button.owner')}
        </Typography>
      )}
      <Dialog open={showModal} onClose={() => setShowModal(false)} maxWidth="lg" fullWidth>
        <DialogContent>
          {fetchedReports?.length !== 8 && (
            <Box>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {t('reports.create.heading', { what: 'review' })}
              </Typography>
              <ReviewReportCreate reviewId={reviewId} />
            </Box>
          )}
          {fetchedReports?.length > 0 && (
            <Box>
              <Typography variant="h6" sx={{ mt: 2 }}>
                {t('reports.edit.heading')}
              </Typography>
              <ReviewReportEdit reviewId={reviewId} />
            </Box>
          )}
        </DialogContent>
        <IconButton onClick={handleCancel} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
      </Dialog>
    </>
  );
}

ReviewReport.propTypes = {
  reviewId: PropTypes.number.isRequired,
  owner: PropTypes.string.isRequired,
};

export default ReviewReport;
